<template>
  <v-row no-gutters>
    <v-col class="col-5 m-t-15 col-md-5 col-sm-12 bold-900">
      {{ $t('appointments.detail.motorbike-reception').toUpperCase() }}
    </v-col>
    <v-col class="col-7 col-md-7 col-sm-12">
      <time-interval-form
        v-bind="$attrs"
        :clearable="false"
        :title1="$t('appointments.detail.motorbike-reception-date').toUpperCase()"
        :title2="$t('appointments.detail.motorbike-reception-time').toUpperCase()"
        :interval="interval"
        :containerId="containerId"
        :apiFunction="getAppointmentDay"
        :notBefore="notBefore"
        id="reception-date" />
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

import coreApi from '@/api/core.api'
import TimeIntervalForm from '@/components/other/TimeIntervalForm'

export default {
  components: {
    TimeIntervalForm,
  },
  props: {
    containerId: {
      type: String,
    },
    interval: {
      type: Object,
    },
    dealerId: {
      type: String,
    },
    notBefore: Date,
  },
  methods: {
    async getAppointmentDay() {
      try {
        const res = await coreApi.getAppointmentDay(this.dealerId, moment(this.interval.day).format('YYYY-MM-DD'))
        return res
      } catch (error) {
        console.error('Error fetching opening hours', error)
        throw error
      }
    },
  },
}
</script>
<style scoped>
.redbg {
  color: red !important;
}
</style>
